import PropTypes from 'prop-types'
import { Table as BaseTable } from 'semantic-ui-react'

const Row = ({ testId = undefined, ...rest }) => (
  <BaseTable.Row data-testid={testId} {...rest} />
)

Row.propTypes = {
  children: PropTypes.node,
  /* Forwarded as data-testid to the <tr>. Use business identity, e.g.
     `{tableTestId}-row-{orderId}`; never the row index. */
  testId: PropTypes.string,
}

export default Row
